import { isEmpty } from 'lodash';
import moment from 'moment';

const upsertUserPayload = (formField) => {
  const payload = { isLdap: false };

  if (formField?.name) payload.name = formField?.name;
  if (formField?.email) payload.email = formField?.email;
  if (formField?.password) payload.password = formField?.password;
  if (formField?.role?.value) payload.roleId = formField?.role?.value;
  if (formField?.nik) payload.nik = formField?.nik;
  if (formField?.role?.isHost) {
    if (!isEmpty(formField?.brand)) payload.brand = [formField?.brand.value];
  } else {
    if (formField?.brand?.length) payload.brand = formField.brand.map((brand) => brand.value);
  }
  if (formField?.ecommerces?.length) payload.ecommerces = formField.ecommerces.map((brand) => brand.value);
  if (formField?.handphone) payload.handphone = formField?.handphone;
  if (formField?.address) payload.address = formField?.address;
  if (formField?.gender?.value) payload.gender = formField?.gender?.value;
  if (formField?.domicile) payload.domicile = formField?.domicile;
  if (formField?.nip) payload.nip = formField?.nip;
  if (formField?.joinDate) payload.joinDate = moment(formField?.joinDate).format('YYYY-MM-DD');
  if (formField?.terminateDate) payload.terminateDate = moment(formField?.terminateDate).format('YYYY-MM-DD');

  return payload;
};

export default upsertUserPayload;
